import { Injectable } from '@angular/core';
import { SharedLanguageService } from '@language';
import { BaseSandbox, StoreService, UserStoreService } from '@mediahaven/shared';
import { ShToastFactory } from '@stylehaven/components';

@Injectable({ providedIn: 'root' })
export class BootstrapSandboxService extends BaseSandbox {
    constructor(
        protected storeService: StoreService,
        protected userStoreService: UserStoreService,
        protected translateService: SharedLanguageService,
        protected toastFactory: ShToastFactory
    ) {
        super();
    }
}
